import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { driverApi } from '../services/driverApi';

export const useUpdateDispatchStatus = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      dispatchId,
      status,
      version,
      additionalInfo,
    }: {
      dispatchId: string;
      status: string;
      version?: number;
      additionalInfo?: Record<string, any>;
    }) => {
      const token = await getAccessTokenSilently();
      driverApi.setAuthToken(token);
      return driverApi.updateDispatchStatus(
        dispatchId,
        status,
        version,
        additionalInfo
      );
    },
    onSuccess: (data, variables) => {
      // Invalidate and refetch driver calls to get updated data
      queryClient.invalidateQueries({ queryKey: ['driver-calls'] });

      // Also invalidate the specific call query that CallScreen is using
      queryClient.invalidateQueries({
        queryKey: ['driver-call', variables.dispatchId],
      });

      // Optionally, we could also invalidate all driver-call queries
      queryClient.invalidateQueries({ queryKey: ['driver-call'] });
    },
    onError: (error: any, variables, context) => {
      console.error('Failed to update dispatch status:', error);

      // Check if it's a version conflict
      if (error.message?.includes('Version conflict')) {
        // Invalidate the call query to get the latest version
        queryClient.invalidateQueries({
          queryKey: ['driver-call', variables.dispatchId],
        });
      }

      // Error will be handled by the component
      throw error;
    },
  });
};
